// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"119":"store","439":"contatti","443":"about","728":"soluzioni","918":"progetto"}[chunkId] + "." + {"119":"dad87d7c","439":"127145c0","443":"22511ca6","728":"736c6a15","918":"bd90f531"}[chunkId] + ".css";
};